module.exports = __webpack_public_path__ + "static/media/autoglass-logo-1.26464b16.png";